// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { sendDeclineBidNotification } from "@steiner/App/Services/OpenBidsService";

type HandlerType = ApiHandler<any & HasOnSuccess, any>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = {
        CustomerNotes: props.parameter.order.orderHeader?.internalNotes,
        Company: props.parameter.order.orderHeader?.billTo.entity.entityName,
        DateSubmitted: props.parameter.order.orderHeader?.orderDate.date,
        OrderNumber: props.parameter.order.orderHeader?.orderId,
        GenerationId: props.parameter.order.orderHeader?.generationId,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await sendDeclineBidNotification(props.apiParameter);
    } catch (error) {
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, RequestDataFromApi, ExecuteOnSuccessCallback];

const declineBid = createHandlerChainRunner(chain, "declineBid");

export default declineBid;
